// Copyright (c) 2016 Deere & Company

import {
    getRejectedReason,
    updateRejectedReason
} from './rejected-reason';
import {
    resetTransferResults,
    updateTransferResultsWithFacets
} from './facet-updates';
import {
    selectAllDealersOnInitialLoad,
    toggleTransferApprovalFacetItems,
    updateDealerAccountFacetInput,
    updateRequestedDateRangeFacet,
    updateTransferApprovalFacetItem
} from './facets';
import {exportToExcel} from './export-to-excel';
import exportToExcelActions from '../../../shared/action-creators/excel-layout-modal-actions-combined';
import {highRentalDaysExportToExcel} from '../../shared/action-creators/high-rental-days-export-to-excel.js';
import {readMachineStatusUpdates} from '../../machine-status-update/action-creators/get-machine-status-updates';
import sharedActionCreators from '../../shared/action-creators';
import {toggleReportsAccordion} from '../../shared/action-creators/reports-accordion';
import {updateFactoryDuplicatePinPlateResults} from '../../factory-users-duplicate-pin-plate/action-creators/factory-duplicate-pin-plates.js';
import {updateRegistrationResults} from '../../registration-review/action-creators/registration';
import {updateTransferComment} from './comment';
import {updateTransferResults} from './search';
import {updateTransferStatus} from './status';

export default {
    ...exportToExcelActions,
    ...sharedActionCreators,
    exportToExcel,
    getRejectedReason,
    highRentalDaysExportToExcel,
    readMachineStatusUpdates,
    resetTransferResults,
    selectAllDealersOnInitialLoad,
    toggleReportsAccordion,
    toggleTransferApprovalFacetItems,
    updateDealerAccountFacetInput,
    updateFactoryDuplicatePinPlateResults,
    updateRegistrationResults,
    updateRejectedReason,
    updateRequestedDateRangeFacet,
    updateTransferApprovalFacetItem,
    updateTransferComment,
    updateTransferResults,
    updateTransferResultsWithFacets,
    updateTransferStatus
};



// WEBPACK FOOTER //
// ./src/product/transfers/action-creators/index.js